import { render } from "./post-smtp-card.vue?vue&type=template&id=3753d82c&scoped=true"
import script from "./post-smtp-card.vue?vue&type=script&lang=js"
export * from "./post-smtp-card.vue?vue&type=script&lang=js"

import "./post-smtp-card.vue?vue&type=style&index=0&id=3753d82c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3753d82c"]])

export default __exports__